// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".afc8dc95dc9a3fa4cb0e5ee03453c7d3.js";
};